"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
  var _console;

  if (undefined) (_console = console).log.apply(_console, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-draggable/build/cjs/utils/log.js
// module id = 1460
// module chunks = 2